import { DOCUMENT_FETCHING, DOCUMENT_FAILED, DOCUMENT_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DOCUMENT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DOCUMENT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DOCUMENT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
